import React, { useEffect, useRef, useState } from "react";
import {
  HStack,
  Image,
  Stack,
} from "@chakra-ui/react";
import GridView from "./Library/GridView";
import TabularView from "./Library/TabularView";
import { useNavigate } from "react-router-dom";
import { totalFilterCount, updateFacetsData } from "../../../util/helper";
import * as getSearchLibraryData from "../../../services/Search";

const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;
const loaderImg = `${IMAGE_BASE_PATH}/ui/Chevron/loader.gif`;

export const Library = ({
  visible,
  SearchTerm,
  setLibraryCount,
  masterlistType = "search",
  filterbuttonStyle,
  onSortDataChange
}) => {
  const [showFilterBox, setShowFilterBox] = useState(false);
  const [apply, setApply] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterPills, setFilterPills] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredResultCount, setFilteredResultCount] = useState(0);
  const [reset, setReset] = useState(false);

  const navigate = useNavigate();

  const handleFilterClick = () => {
    setShowFilterBox(!showFilterBox);
  };

  const handleItemNavigation = (item) => {
    navigate(`/libraries/${item?.alias}`);
  };

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    filters: {},
    gate:"AND",
    sortBy_v: "sortable_year"
  });

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    handleCheckboxChange("searches",e.target.value)
  };

  const handleCheckboxChange = (value, type) => {
    let selectedArray = [];
    let selectedString = "";  
    switch (value) {
      case "sort":
        selectedString = filterOptions.sortBy_v;
        break;
        case "gate":
          selectedString = filterOptions.gate;
          break;
      case "searches":
        selectedString = filterOptions.search;
        break;
      default:
        if (value in filterOptions.filters) {
          selectedArray = filterOptions.filters[value];
        }
        break;
    }
  
    if (Array.isArray(type)) {
      // Bulk replace (used by FilterBody's "Select All" / clear-all toggle)
      // rather than the usual single-value toggle below.
      selectedArray = type;
    } else if (selectedArray.includes(type)) {
      selectedArray = selectedArray.filter((checkbox) => checkbox !== type);
    } else {
      selectedArray = [...selectedArray, type];
    }
  
    if (selectedString !== type) {
      selectedString = type;
    }
  
    switch (value) {
      case "sort":
        setFilterOptions(prevFilterOptions => ({
          ...prevFilterOptions,
          sortBy_v: selectedString,
        }));
        break;
        case "gate":
          setFilterOptions(prevFilterOptions => ({
            ...prevFilterOptions,
            gate: selectedString,
          }));
          break;
      case "searches":
        setFilterOptions(prevFilterOptions => ({
          ...prevFilterOptions,
          search: selectedString,
        }));
        break;
      default:
        if (value in filterOptions.filters) {
          setFilterOptions(prevFilterOptions => ({
            ...prevFilterOptions,
            filters: {
              ...prevFilterOptions.filters,
              [value]: selectedArray,
            },
          }));
        }
        break;
    }
  };
  const citationFactor = (data) => {
    return data.map((item) => {
      const imagePath =item?.find((nestedItem) => nestedItem?.key === "direct_url_of_cover_image")?.value || item?.find((nestedItem) => nestedItem?.key === "direct_url_of_preview_image")?.value || "";
      const firstName = item?.find((nestedItem) => nestedItem?.key === "creator_first_name")?.value
      const lastName = item?.find((nestedItem) => nestedItem?.key === "creator_surname")?.value
      const creatorName=item?.find((nestedItem) => nestedItem?.key === "creator_name")?.value
      const author = lastName && firstName ? `${firstName} ${lastName}` : "";
      const bookKey =
        item?.find((nestedItem) => nestedItem?.key === "title")?.value || null;
      const book = bookKey;
      const link =
        item?.find((nestedItem) => nestedItem?.key === "drawer_link")?.value ||
        null;

      const docType =
        item?.find((nestedItem) => nestedItem?.key === "document_type")
          ?.value || null;
      const typeCreator =
        item?.find((nestedItem) => nestedItem?.key === "type_of_creator")
          ?.value || null;
          const fullname = creatorName!=="" ? author : creatorName;
          const sliderImage =
        item?.find((nestedItem) => nestedItem?.key === "drawer_image_alias")
          ?.value ?
        item?.find((nestedItem) => nestedItem?.key === "drawer_image_alias")
          ?.value : '';
      const bibliograhpic_citation =
        item?.find((nestedItem) => nestedItem?.key === "bibliograhpic_citation")
          ?.value ||
        item?.find((nestedItem) => nestedItem?.key === "bibliographic_citation")
          ?.value ||
        "";
        const bibliograhpic_caption =
        item?.find((nestedItem) => nestedItem?.key === "bibliographic_caption")
          ?.value ||
        item?.find((nestedItem) => nestedItem?.key === "bibliographic_caption")
          ?.value ||
        "";
      const desc =  bibliograhpic_citation || "";
      const listDesc= bibliograhpic_caption || '';
      const alias = item?.find(
        (nestedItem) => nestedItem?.key === "alias"
      )?.value;
      const title = item?.find(
        (nestedItem) => nestedItem?.key === "title"
      )?.value;
      const header = `${title ? title :''}`;
      const publisher = item?.find(
        (nestedItem) => nestedItem?.key === "place_of_publication"
      )?.value;
      const bookCaption =
        item?.find((nestedItem) => nestedItem?.key === "book_caption")?.value ||
        null;
      const publicationYear =
        item?.find((nestedItem) => nestedItem?.key === "sortable_year")
          ?.value || null;
          const firstEdition =
        item?.find((nestedItem) => nestedItem?.key === "date_of_first_edition")
          ?.value || null;
      const details_page = item?.find((nestedItem) => nestedItem?.key === "details_page")?.value;

      return {
        imagePath,
        desc,
        header,
        bookKey,
        link,
        typeCreator,
        book,
        author,
        docType,
        sliderImage,
        fullname,
        alias,
        title,
        publisher,
        bookCaption,
        publicationYear,
        firstEdition,
        listDesc,
        details_page: details_page?.toLowerCase()==="no"?false:true,
        body:[
          {
            text: "Index Page →",
          }
        ],
        footer: [
          {
            text: "Contents Page→",
          },
          {
            text: "Selected Pages→",
          },
          
          ]
      };
    });
  };

  const [facets, setFacets] = useState([]);
  const [sort, setSort] = useState([]);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const initialLoadComplete = useRef(false);
  const [triggerFetch, setTriggerFetch] = useState(false);

  async function fetchData() {
    if (!navigator.onLine) {
      alert("No network connection. Please check your internet connection and try again.");
      setHasMore(false);
      return;
    }
    try {
      setIsLoading(true);
      const result = await getSearchLibraryData.searchResearchLibraryTab(
        SearchTerm,
        filterOptions,
        1
      );
      setIsLoading(false);

      if (result) {
        // Set facets regardless of whether there's data
        if (result?.facetsHeaders && result?.facets) {       
          const formattedFacets = updateFacetsData({ data: result });
          setFacets(formattedFacets);
        
          if (formattedFacets && formattedFacets.length > 0) {
            setFilterOptions((prevFilterOptions) => ({
              ...prevFilterOptions,
              filters: {
                ...prevFilterOptions.filters,
                ...formattedFacets.reduce((acc, facet) => {
                  acc[facet.key] = [];
                  return acc;
                }, {}),
              },
            }));
          }
        }

        // Set sort options
        const sortedFacets = result?.sortByHeader?.map((obj) => {
          const key = Object.keys(obj)[0];
          return { key: key, display: obj[key] };
        });
        setSort(sortedFacets);

        if (result?.data && result?.data.length > 0) {
          const processedData = citationFactor(result?.data);
          setData(processedData);
          setLibraryCount(result?.total || 0);
          if (!initialLoadComplete.current) {
            setPage(page + 1);
            initialLoadComplete.current = true;
          }
          
          if(result.total===result?.data.length) {
            setHasMore(false)
          }
        } else {
          setData([])
          setLibraryCount(result?.total || 0)
        }

        if (onSortDataChange) {
          onSortDataChange({
            sort: sortedFacets,
            filterOptions,
            handleCheckboxChange,
            setApply,
            hasData: result?.data?.length > 0,
            showFilterBox,
            handleFilterClick,
            filterAvailable: facets && facets.length > 0
          });
        }
      } else {
        setData([])
        setLibraryCount(0)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  }
  const handleResetPage=()=>{
    initialLoadComplete.current = false;
    setHasMore(true);
    setPage(1);
    setTriggerFetch(prev => !prev);
  }

  useEffect(() => {
    handleResetPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SearchTerm]);
  
  // Register functions immediately when component mounts or SearchTerm changes
  useEffect(() => {
    if (onSortDataChange) {
      onSortDataChange({
        sort,
        filterOptions,
        handleCheckboxChange,
        setApply,
        hasData: data && data.length > 0,
        showFilterBox,
        handleFilterClick,
        filterAvailable: facets && facets.length > 0
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SearchTerm, showFilterBox]);
  
  useEffect(() => {
    fetchData();
    setFilterPills(filterOptions)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerFetch]);

  const fetchMoreData = async () => {
    if (!navigator.onLine) {
      alert("No network connection. Please check your internet connection and try again.");
      setHasMore(false);
      return;
    }
    try {
      const result = await getSearchLibraryData.searchResearchLibraryTab(
        SearchTerm,
        filterOptions,
        page
      );

      if (result) {
        const processedData = citationFactor(result?.data);
        setData((prevData) => [...prevData, ...processedData]);
        setPage(page + 1);
        const sortedFacets = result?.sortByHeader?.map((obj) => {
          const key = Object.keys(obj)[0];
          return { key: key, display: obj[key] };
        });
        setSort(sortedFacets);
        if (onSortDataChange) {
          onSortDataChange({
            sort: sortedFacets,
            filterOptions,
            handleCheckboxChange,
            setApply,
            hasData: result?.data?.length > 0,
            showFilterBox,
            handleFilterClick,
            filterAvailable: facets && facets.length > 0
          });
        }
        if (data?.length >= result?.total){
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  async function fetchFilterData(page=1) {
    if (!navigator.onLine) {
      alert("No network connection. Please check your internet connection and try again.");
      setHasMore(false);
      return;
    }
    try {
      setIsLoading(true);
      const result = await getSearchLibraryData.searchResearchLibraryTab(
        SearchTerm,
        filterOptions,
        page
      );
      setIsLoading(false);
      if (result) {
        const processedData = citationFactor(result?.data);
        setData(processedData);
        setPage(prev=>prev+1)
        const sortedFacets = result?.sortByHeader?.map((obj) => {
          const key = Object.keys(obj)[0];
          return { key: key, display: obj[key] };
        });
        setSort(sortedFacets);
        if (onSortDataChange) {
          onSortDataChange({
            sort: sortedFacets,
            filterOptions,
            handleCheckboxChange,
            setApply,
            hasData: result?.data?.length > 0,
            showFilterBox,
            handleFilterClick,
            filterAvailable: facets && facets.length > 0
          });
        }
        const filtercnt= totalFilterCount(filterOptions?.filters)
        if(filtercnt>0 || filterOptions?.search){
          setFilteredResultCount(result?.total)
        }else{
          setFilteredResultCount(0);
        }
        if (result?.data?.length >= result?.total) {
          setHasMore(false);
        }

        if (result?.facetsHeaders && result?.facets) {
          const formattedFacets = updateFacetsData({ data: result });
          setFacets(formattedFacets);
          if (formattedFacets && formattedFacets.length > 0 && reset) {
            setFilterOptions((prevFilterOptions) => ({
              ...prevFilterOptions,
              filters: {
                ...prevFilterOptions.filters,
                ...formattedFacets.reduce((acc, facet) => {
                  acc[facet.key] = [];
                  return acc;
                }, {}),
              },
            }));
            setReset(false);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  }
  useEffect(() => {
    if (onSortDataChange) {
      onSortDataChange({
        sort,
        filterOptions,
        handleCheckboxChange,
        setApply,
        hasData: data && data.length > 0,
        showFilterBox,
        handleFilterClick,
        filterAvailable: facets && facets.length > 0
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sort, filterOptions, data, handleCheckboxChange, setApply, showFilterBox]);

  useEffect(() => {
    if (apply) {
      if(masterlistType==="search"){
        window.scrollTo(0, 0);
      }
      setApply(false);
      setHasMore(true);
      setPage(1)
      fetchFilterData();
      setFilterPills(filterOptions)

    }
    const filtercnt= totalFilterCount(filterOptions?.filters)
    setFilterCount(filtercnt)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apply]);

    const handleReset = () => {
      setFilteredResultCount(0);
      const initializedFilters = facets.reduce((acc, facet) => {
        acc[facet.key] = [];
        return acc;
      }, {});
      setFilterOptions({
        search: "",
        filters: initializedFilters,
        sortBy_v: "sortable_year",gate:"AND"
      });
      setFilterCount(0)
      setSearchTerm("");
      setReset(true);
    }

  return (
    <>
    {!isLoading ? (
    <Stack>
      {visible ? (
        <>
          <GridView
            handleDrawer={handleItemNavigation}
            masterlistType={masterlistType}
            fetchMoreData={fetchMoreData}
            data={data}
            filterPills={filterPills}
            setFilterPills={setFilterPills}
            showFilterBox={showFilterBox}
            handleFilterClick={handleFilterClick}
            hasMore={hasMore}
            setShowFilterBox={setShowFilterBox}
            setApply={setApply}
            sort={sort}
            handleCheckboxChange={handleCheckboxChange}
            handleSearch={handleSearch}
            filterOptions={filterOptions}
            filteroptionData={facets}
            setFilterOptions={setFilterOptions}
            setSearchTerm={setSearchTerm}
            filterCount={filterCount}
            searchTerm={searchTerm}
            handleReset={handleReset}
            filterbuttonStyle={filterbuttonStyle}
            filteredResultCount={filteredResultCount}
          />
        </>
      ) : (
        <>
          <TabularView
            masterlistType={masterlistType}
            filterPills={filterPills}
            setFilterPills={setFilterPills}
            fetchMoreData={fetchMoreData}
            data={data}
            showFilterBox={showFilterBox}
            handleFilterClick={handleFilterClick}
            hasMore={hasMore}
            handleDrawer={handleItemNavigation}
            setShowFilterBox={setShowFilterBox}
            setApply={setApply}
            sort={sort}
            handleCheckboxChange={handleCheckboxChange}
            handleSearch={handleSearch}
            filterOptions={filterOptions}
            filteroptionData={facets}
            setFilterOptions={setFilterOptions}
            setSearchTerm={setSearchTerm}
            filterCount={filterCount}
            searchTerm={searchTerm}
            handleReset={handleReset}
            filterbuttonStyle={filterbuttonStyle}
            filteredResultCount={filteredResultCount}
          />
        </>
      )}
    </Stack>):
    (
      <HStack justifyContent={"center"} minH={"100vh"} alignItems={"flex-start"} mt={4}>
          <Image src={loaderImg} width={"100px"} height={"100px"} alt="Loading" />
      </HStack>
    )
  }
    </>
  );
};

